import { render, staticRenderFns } from "./BaseComparableTextField.vue?vue&type=template&id=70d40f9e&scoped=true"
import script from "./BaseComparableTextField.vue?vue&type=script&lang=js"
export * from "./BaseComparableTextField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d40f9e",
  null
  
)

export default component.exports